export class Race {
  public id: string;
  public name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }

  static parse(obj: any): Race {
    if (!obj) return;

    return new Race(obj.id, obj.name);
  }
}
